// extracted by mini-css-extract-plugin
module.exports = {"VertifyPhone":"_1_T8BA9gXL_b4yzVODbsQC"};